var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGlobe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19610"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19596",
  transform: "translate(-583 -29)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "none",
  "data-name": "Ellipse 1391",
  transform: "translate(583 29)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 15154"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M588.633 34.592h19.527v19.527h-19.527z",
  "data-name": "Rectangle 6436"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 15153"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 15152",
  transform: "translate(591.073 37.032)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.42.425s-3.182 1.068-3.182 7 3.182 6.946 3.182 6.946",
  "data-name": "Path 16706"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.42.425s3.183 1.068 3.183 7-3.183 6.946-3.183 6.946",
  "data-name": "Path 16707"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.42,
  cy: 7.42,
  r: 7.42,
  "data-name": "Ellipse 1553"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 7.42h14.841",
  "data-name": "Line 1281"
}))))))));
export { SvgGlobe as ReactComponent };
export default __webpack_public_path__ + "static/media/globe.ca88d9d7a77347e0ee22deb740c5f1c8.svg";